import { render, staticRenderFns } from "./ANxAPxMedicalPage.vue?vue&type=template&id=7c4f65c9"
import script from "./ANxAPxMedicalPage.vue?vue&type=script&lang=js"
export * from "./ANxAPxMedicalPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports